package com.crowpay.extensions

import com.crowpay.FlowPermissions
import com.crowpay.views.screens.common.ActionImportance

fun FlowPermissions.requiresAction(concernsOnly: Boolean = false): ActionImportance? =
    when {
        !awaitingResponse || messages.isEmpty() || completed -> null
        disputeWasFiled -> ActionImportance.Critical
        issueWasRaised || concernRaised -> ActionImportance.Important
        concernsOnly -> null
        else -> ActionImportance.Important
    }